// Example starter JavaScript for disabling form submissions if there are invalid fields
(() => {
	'use strict'

	//Fetch all required inputs
	const inputs = document.querySelectorAll('input[type=text][required], input[type=checkbox][required], input[type=radio][required]');

	Array.from(inputs).forEach(input => {
		input.addEventListener('change', function() {
			if(input.type === "text") {
				if(this.value !== "") {
					$("input").closest( ".form-group" ).find(".invalid-feedback").hide();
				}
			} else if(input.type === "checkbox") {
				let checked = $("input[name='"+this.name+"']:checked").length;

				$.each($("input[name='"+this.name+"']"), function() {
					if(checked > 0) {
						this.removeAttribute('required');
						$(input).closest( ".cb_group" ).find(".invalid-feedback").hide();
					} else {
						this.setAttribute('required', 'required');
						$(input).closest( ".cb_group" ).find(".invalid-feedback").show();
					}
				});
			} else if(input.type === "radio") {
				let checked = $("input[name='"+this.name+"']:checked").length;

				if(checked > 0) {
					$(input).closest( ".form-group" ).find(".invalid-feedback").hide();
				}
			}
		});
	});


	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	const forms = document.querySelectorAll('.needs-validation');

	// Loop over them and prevent submission
	Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {

			if(!form.checkValidity()) {
				event.preventDefault()
				event.stopPropagation()

				$("input").closest( ".form-group" ).find(".invalid-feedback").hide();
				$("select").closest( ".form-group" ).find(".invalid-feedback").hide();
				$("select").closest( ".form-group" ).find(".custom-dropdown").removeClass('is-invalid');

				let errorElements = document.querySelectorAll("input:invalid, select:invalid");

				if(errorElements.length > 0) {
					errorElements.forEach(function(element) {

						if(element.type === "text" || element.type === "file") {
							$(element).closest( ".form-group" ).find(".invalid-feedback").show();
							$(element).closest( ".form-group" ).find(".custom-dropdown").addClass('is-invalid');

						} else if(element.type === "select-one" || element.type === "select-multiple") {
							if(element.required) {
								if(element.value === "") {
									$(element).closest( ".form-group" ).find(".invalid-feedback").show();
									$(element).closest( ".form-group" ).find(".custom-dropdown").addClass('is-invalid');
								}
							}
						} else if(element.type === "radio" ) {
							$(element).closest( ".form-group" ).find(".invalid-feedback").show();
						} else if(element.type === "checkbox") {
							$(element).closest( ".cb_group" ).find(".invalid-feedback").show();
						}
					});

					$('html, body').animate({
						scrollTop: ($(errorElements[0]).offset().top - 32)  //32 voor label
					}, 1000);
				}
			}

			form.classList.add('was-validated')
		}, false)
	});

	$("input[type='file']").change(function() {
		let filename = this.files[0].name;

		$(this).closest( ".form-group" ).find(".custom-file-label").html(filename);
	});
})()


var Ldjn = (function lerendoejenu($) {
	let $body = $('body');

	function fontSizer(fs) {
		if(fs == null) {
			let cookie = BART.Front.Util.readCookie('bnl_fontsize');
			if(cookie != null) {
				fs = cookie;
			}
		} else {
			BART.Front.Util.createCookie('bnl_fontsize', fs, 365);
		}
		if(fs != null) {
			$body
				.removeClass('small medium large')
				.addClass(fs);
		} else {
			$body.addClass('medium');
		}
	}

	function switchContrast(toggle) {
		let htmlRoot = document.documentElement;
		(toggle === 'on') ? $(htmlRoot).addClass('high_contrast') : $(htmlRoot).removeClass('high_contrast');
		// $('link[rel*=style][title="contrast"]')[0].disabled = !(toggle === 'on');
		BART.Front.Util.createCookie('bnl_contrast', toggle, 365);
	}

	function preparePassword(frm, secure) {
		let el_pw = document.getElementById('mod_restriction_password');
		let el_pw_submit = document.getElementById('mod_restriction_password_submit');
		if ((typeof (el_pw) !== 'undefined' && el_pw != null) && (typeof (el_pw_submit) !== 'undefined' && el_pw_submit != null)) {
			if(el_pw.value !== '') {
				if(secure) {
					let session_id = BART.Front.Util.readCookie('PHPSESSID');
					if(session_id.length) {
						el_pw_submit.value =
							BART.Front.Util.md5(session_id + el_pw.value);
					}
				} else {
					el_pw_submit.value = el_pw.value;
				}
				el_pw.disabled = true;
			}
		}
	}

	function badBrowser() {
		window.$buoop = {
			required:{
				e:-1,f:-4,o:-4,s:8,c:-4
			},
			reminder:4,
			test:false,
			insecure:false,
			api:2021.11
		};
		(function $buo_f(){
			const e = document.createElement("script");
			e.src = "//browser-update.org/update.min.js";
			document.body.appendChild(e);
		})();
	}

	// initialize google map (this function is called as a callback in the script tag)
	function initGmap() {
		let el_map = document.querySelector(".gmap");
		// eslint-disable-next-line no-unused-vars
		let gmap, marker, latlong_from_address, str_address;
		if (el_map) {
			str_address = (el_map.dataset.gmapStreet) ? el_map.dataset.gmapStreet : " ";
			str_address += (el_map.dataset.gmapHousenumber) ? el_map.dataset.gmapHousenumber : " ";
			str_address += (el_map.dataset.gmapZipcode) ? el_map.dataset.gmapZipcode : " ";
			str_address += (el_map.dataset.gmapCity) ? el_map.dataset.gmapCity : " ";

			let lat = (el_map.dataset.gmapLat) ? el_map.dataset.gmapLat : "";
			let lng = (el_map.dataset.gmapLng) ? el_map.dataset.gmapLng : "";

			let zoom_level = (el_map.dataset.gmapZoomlevel) ? el_map.dataset.gmapZoomlevel : 14;
// console.log(zoom_level);
			if(lat !== "" && lng !== "") {
				let lat_lng = new google.maps.LatLng(lat, lng);

				gmap = new google.maps.Map(el_map, {
					center: lat_lng,
					streetViewControl: false,
					mapTypeControl: false,
					zoom: parseInt(zoom_level)
				});
				el_map.classList.add('visible');
				marker = new google.maps.Marker({
					position: lat_lng,
					clickable: false,
					map: gmap
				});

			} else {
				latlong_from_address = new google.maps.Geocoder();
				latlong_from_address.geocode({'address': str_address}, function(results, status) {
					if (status === "OK") {
						let geo_loc = results[0]['geometry']['location'];
						if (typeof geo_loc !== 'undefined' && geo_loc != null) {
							let lat = geo_loc['lat'];
							let lng = geo_loc['lng'];
							if ((typeof (lat) !== 'undefined' && lat != null) && (typeof (lng) !== 'undefined' && lng != null)) {
								lat = lat();
								lng = lng();
								gmap = new google.maps.Map(el_map, {
									center: {lat: lat, lng: lng},
									streetViewControl: false,
									mapTypeControl: false,
									zoom: parseInt(zoom_level)
								});
								el_map.classList.add('visible');
								marker = new google.maps.Marker({
									position: {lat: lat, lng: lng},
									clickable: false,
									map: gmap
								});
							}
						}
					} else {
						console.log('Geocode was not successful for the following reason: ' + status);
					}
				});
			}
		}
	}

	// datepicker
	(function initFlatpickr () {
		// let flatpickr = null;
		let initflatpicr_el = document.querySelector(".search-form-date-box.flatpickr");
		if (typeof (initflatpicr_el) !== 'undefined' && initflatpicr_el != null) {
			let optional_config = {
				altInput: true,
				altFormat: "j-F-Y",
				dateFormat: "Y-m-d",
				// disableMobile: true,
				onReady: function() { // flatpickr bug workaround, when placeholder is set in HTML, it will be set as value in IE(11) on flatpickr init
					if (typeof this.altInput !== 'undefined' && typeof this.altInput.placeholder !== 'undefined') {
						this.altInput.placeholder = 'Selecteer datum';
						this.altInput.title = 'Selecteer datum';
					}
				},
				locale: "nl"
			};
			// flatpickr = $("#search_date").flatpickr(optional_config);
			$("#search_date").flatpickr(optional_config);
		}
	})();

	// data-trigger-toggle-ctype
	// registration page toggle customer type
	(function toggle_customer_type() {
		let trigger_toggle_ctype = document.querySelector("[data-trigger-toggle-ctype]");
		if (trigger_toggle_ctype) {
			if (trigger_toggle_ctype.dataset.triggerToggleCtype === "union") {
				$('.private_person').hide();
				$('.union').show();
			} else {
				$('.private_person').show();
				$('.union').hide();
			}
		}
	})();

	// auto validate
	(function jq_validate() {
		let validateForms = document.querySelectorAll('[data-trigger-validate]');
		Array.prototype.forEach.call(validateForms, function (e) {
			$(e).validate();
		});
	})();

	// init social login
	(function init_social_login() {
		let trigger_init_social_login = document.querySelectorAll('[data-trigger-init-sociallogin]');
		Array.prototype.forEach.call(trigger_init_social_login, function (e) {
			let curr_source = e.dataset.socialLoginSource || "/";
			let curr_webroot = e.dataset.socialLoginWebroot || "/";
			let curr_b_login_form = !!(e.dataset.socialLoginLoginForm && e.dataset.socialLoginLoginForm === "true");
			let curr_bicat_page = e.dataset.socialLoginBicatPage ? e.dataset.socialLoginBicatPage : '';
			BART.SocialLogin.Main.init({
				web_root: curr_webroot,
				login_form: curr_b_login_form,
				source: curr_source,
				bicat_page: curr_bicat_page
			});
		});
	})();

	// prepare passwords
	(function init_prepare_passwords() {
		let trigger_prepare_password = document.querySelectorAll('[data-trigger-prepare-password]');
		Array.prototype.forEach.call(trigger_prepare_password, function (e) {
			$(e).on("submit", function() {
				let curr_trigger_val = e.dataset.triggerPreparePassword;
				preparePassword(e, curr_trigger_val);
				return true;
			});
		});
	})();

	// toggle password input visibility on icon-eye click
	(function toggle_password_visibility() {
		const iconsTogglePasswordVisibility = document.querySelectorAll('.js-toggle-password-visibility');
		const inputPasswordsToToggle = document.querySelectorAll('.js-show-on-icon-evt');
		[...iconsTogglePasswordVisibility].forEach(icon => {
			icon.addEventListener('click', () => {
				_toggleEyeClassLists();
				_toggleInputType();
			})
		})
		function _toggleEyeClassLists() {
			[...iconsTogglePasswordVisibility].forEach(e => e.classList.toggle('-active'));
		}
		function _toggleInputType() {
			[...inputPasswordsToToggle].forEach(e => e.type = e.type === 'password' ? 'text' : 'password');
		}
	})();

	return {
		fontSizer: fontSizer,
		switchContrast: switchContrast,
		initGmap: initGmap,
		badBrowser: badBrowser
	}

})(jQuery);

(function($) {
	$(function() {
		//Font Sizer
		$("a.small").click(function(e) {
			e.preventDefault();
			Ldjn.fontSizer('small');
		});

		$("a.medium").click(function(e) {
			e.preventDefault();
			Ldjn.fontSizer('medium');
		});

		$("a.large").click(function(e) {
			e.preventDefault();
			Ldjn.fontSizer('large');
		});

		$('.contrast').click(function(e) {
			e.preventDefault();
			e.stopPropagation();
			let cookie = BART.Front.Util.readCookie('bnl_contrast');
			if(cookie === 'off' || cookie == null) {
				Ldjn.switchContrast('on');
			} else {
				Ldjn.switchContrast('off');
			}
		});

		let $img_bart_tooltip = $('img.bart-tooltip');
		if (typeof $img_bart_tooltip.aToolTip === "function") {
			$img_bart_tooltip.aToolTip();
		}

		let popups = $('.biebwidget.info_popup');
		popups.each(function() {
			let popup = $(this);

			if( $(this).prev().find(".help").length > 0 ) {
				$(this).prev().find(".help").mouseover(function() {
					popup.css('top', popup.prev().position().top);
					if (popup.is('.links')) {
						popup.css('left', popup.prev().position().left - popup.outerWidth() - 15 );
					} else {
						popup.css('left', popup.prev().position().left + popup.prev().outerWidth() + 15 );
					}
					popup.show();
				});
				$(this).prev().find(".help").mouseout(function(){
					popup.hide();
				});
			} else {
				$(this).prev().mouseover(function(){
					popup.css('top', $(this).position().top);
					if (popup.is('.links')) {
						popup.css('left', $(this).position().left - popup.outerWidth() - 15 );
					} else {
						popup.css('left', $(this).position().left + $(this).outerWidth() + 15 );
					}
					popup.show();
				});
				$(this).prev().mouseout(function(){
					popup.hide();
				});
			}
		});

		for (let prop in BART.Gadgets) {
			if (Object.prototype.hasOwnProperty.call(BART.Gadgets, prop)) {
				if (Object.prototype.hasOwnProperty.call(BART.Gadgets[prop], 'init')) {
					BART.Gadgets[prop].init({});
				}
			}
		}

		Ldjn.fontSizer(null);
		Ldjn.badBrowser();
		let c = BART.Front.Util.readCookie('bnl_contrast');
		if (c) Ldjn.switchContrast(c);

		let $biblionetheader_searchBtn = $("[data-type='biblionetheader'] button.search");
		$biblionetheader_searchBtn.on("click", function() {
			if ($(this).hasClass('collapsed')) {
				$(this).removeClass('collapsed');
				$(this).addClass('expanded');
				$('#navbar #views-exposed-form-search-page').show();
				$('#navbar #views-exposed-form-search-page input.form-text').animate({
					opacity: '1',
					width: '502px',
					right: '-4px'
				});
				$(this).html('<span class="far fa-times"></span>');
			} else {
				$(this).removeClass('expanded');
				$(this).addClass('collapsed');
				$('#navbar #views-exposed-form-search-page input.form-text').animate({
					opacity: '0',
					width: '45px',
					right: '0',
				}, 400, function () {
					$('#navbar #views-exposed-form-search-page').hide();
				});
				$(this).html('<span class="far fa-search"></span>');
			}
		});

		// generic preventdefault fn based on data attribute
		// example <a href="#" data-trigger="some-js-trigger" data-preventdefault-on="click">
/*		let arr_elems_preventdefault = document.querySelectorAll("[data-preventdefault-on]");
		Array.prototype.forEach.call(arr_elems_preventdefault, function (elem) {
			let event_to_prevent = elem.dataset.preventdefaultOn;
			if (event_to_prevent) {
				elem.addEventListener(event_to_prevent, function(e) {
					e.preventDefault();
				});
			}
		});*/

		// let triggerToggleTimes = document.querySelectorAll("[data-trigger='toggle-times']");
		// Array.prototype.forEach.call(triggerToggleTimes, function (triggerToggleTime) {
/*			$("[data-trigger='toggle-times']").on("click", function(e) {
				e.preventDefault();
				let $timeTable = $(this).next('.times');
				if ($timeTable.length) {
					$timeTable.stop(true,true).slideToggle();
				}
			});*/
		// });

		// removed from internal js in tpl
		$("li.group div.hide").hide();
		$("[data-trigger='jq_less_more']").each(function() {
			$(this).click(function() {
				$("li.group div."+this.name).toggle('slow', function(){
					return false;
				});
			});
		});
	});


	// removed from internal js in tpl
	window.rsConf = {
		general: {
			usePost: true

		},
		ui: {
			disableDetachment: true
		}
	};

})(jQuery);
